import * as CryptoJS from 'crypto-js';
import * as _ from 'lodash';

import {
  Injectable,
  Renderer2,
  RendererFactory2
} from '@angular/core';

import { AzureFileUploadService } from '../azure-upload/azure-file-upload.service';
import { FileData } from 'src/app/common/input-files/component/input-files.component';
import { INVALID_ID_ERROR } from '../../constants/messages';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { ToastService } from '../../components/toast-notification/toast.service';
import { dataURLtoFile } from 'src/app/constants/helper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  // CryptoJS
  cityList = [];
  ShowFooter: Subject<boolean> = new Subject();
  siteUserName = environment.accessSecrets.siteUserName;
  pushOnChat$: Subject<any> = new Subject()
  private $renderer2: Renderer2;
  secretKeyText = environment.accessSecrets.secretKeyText;
  /**
   * command to generate {secretKey}
   * openssl passwd -1 -stdin <<< avtopiaaog@appinventiv@2020
   */
  private secretKey = '$1$U.iV6oX4$584JxcP4YuPXR8z6HhmPV1';
  constructor(
    private $router: Router,
    private $title: Title,
    private $toast: ToastService,
    private $azureUpload: AzureFileUploadService,
    private $rendererFactory: RendererFactory2,
  ) {
    this.$renderer2 = this.$rendererFactory.createRenderer(null, null);
  }

  checkPropertiesEmpty(obj) {
    for (let key in obj) {
      if (obj[key] !== null && obj[key] != "")
        return false;
    }
    return true;
  }

  removeHtmlFromText(str: string): string {
    const divEl: HTMLDivElement = this.$renderer2.createElement('div')
    divEl.innerHTML = str;
    // || divEl.innerHTML.toString() ||
    return divEl.textContent || ''
  }

  replaceHtmlEntities(str: string) {
    let regex = /[&|<|>|"|']/g;
    let htmlString = str.replace(regex, function (match) {
      if (match === "&") {
        return "&amp;";
      } else if (match === "<") {
        return "&lt;"
      } else if (match === ">") {
        return "&gt;";
      } else if (match === '"') {
        return "&quot;";
      } else {
        return "&apos;";
      }
    });

    return htmlString;
  }

  urlMaker = (postInputValue) => {
    const clearedHtml = postInputValue.replace(/</g, "&lt;").replace(/>/g, "&gt;")
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return clearedHtml.replace(urlRegex, function (url) {
      return url;
    })
  }

  sanitizeBody(value) {
    const div: HTMLDivElement = this.$renderer2.createElement('div');
    div.innerHTML = this.urlMaker(value);
    return div.innerHTML;
  }


  deviceDetail(info?: number) {
    /*---1=device_token, 2=deviceId, 3=platform---*/
    switch (info) {
      case 1:
        return "123";
      case 2:
        let deviceId = window.btoa(`${window.navigator.userAgent} ${new Date().getTime()}`)
        return deviceId;
      case 3:
        return "3";
      case 4:
        return this.getTimeZone();

      case 5:
        return window.btoa('Random Device Token')
    }
  }
  getTimeZone() {
    let date = new Date();
    let offset = date.getTimezoneOffset() * -1;
    return offset * 60 * 1000;
  }

  async uploadDocuments(documentStore: FileData[] = [], alreadyUploadedMedia?: any[]): Promise<any> {
    if (!alreadyUploadedMedia) {
      return new Promise(async (resolve, reject) => {
        let fileLength: any = documentStore.length > 1 ? documentStore : documentStore[0];
        const uploadType = documentStore.length > 1 ? true : false;
        let res: any;
        if (uploadType) {
          res = await this.$azureUpload.uploadFiles(fileLength.map(item => item.file))
        } else {
          res = await this.$azureUpload.uploadFile(fileLength.file);
        }
        let image: string[] = [];
        if (res) {
          let media: any;
          media = res;
          if (media.length) {
            media.forEach((element, index) => {
              image.push(element['Location']);
            })
          } else {
            image.push(media.Location)
          }
        }
        if (image && image.length) {
          return resolve(image);
        } else {
          return reject([]);
        }
      })
    } else {
      try {
        const uploadedMedia: any[] = alreadyUploadedMedia.filter(x =>
          documentStore.find(item => item.url == x)
        );
        const newImages: any[] = documentStore.filter(item => !item.url.startsWith('http'))
        if (newImages && newImages.length > 0) {
          const res: any = await this.$azureUpload.uploadFiles(newImages.map(item => item.file))
          if (res) {
            res.forEach((element, index) => {
              uploadedMedia.push(element['Location']);
            })
            return Promise.resolve(uploadedMedia);
          }
        } else {
          return Promise.resolve(uploadedMedia);
        }
      } catch (err) {
        return Promise.reject(null)
      }

    }
  }

  async uploadImages(imagesStore: FileData[] = [], alreadyUploadedMedia?: any[]): Promise<any> {
    if (!alreadyUploadedMedia) {
      return new Promise(async (resolve, reject) => {
        let fileLength: any = imagesStore.length > 1 ? imagesStore : imagesStore[0];
        const uploadType = imagesStore.length > 1 ? true : false;
        let res: any;
        if (uploadType) {
          res = await this.$azureUpload.uploadFiles(fileLength.map(item => item.file))
        } else {
          res = await this.$azureUpload.uploadFile(fileLength.file);
        }
        // if (uploadType) {
        //   res = await this.$uploader.uploadMultipleFiles(fileLength.map(item => item.file))
        // } else {
        //   res = await this.$uploader.uploadFile(fileLength.file);
        // }

        let image: string[] = [];
        if (res) {
          let media: any;
          media = res;
          if (media.length) {
            media.forEach((element, index) => {
              image.push(element['Location']);
            })
          } else {
            image.push(media.Location)
          }
        }
        if (image && image.length) {
          return resolve(image);
        } else {
          return reject([]);
        }
      })
    } else {
      try {
        const uploadedMedia: any[] = alreadyUploadedMedia.filter(x =>
          imagesStore.find(item => item.url == x)
        );
        //;
        const newImages: any[] = imagesStore.filter(item => !item.url.startsWith('http'))
        if (newImages && newImages.length > 0) {
          const res: any = await this.$azureUpload.uploadFiles(newImages.map(item => item.file))
          if (res) {
            res.forEach((element, index) => {
              uploadedMedia.push(element['Location']);
            })
            return Promise.resolve(uploadedMedia);
          }
        } else {
          return Promise.resolve(uploadedMedia);
        }
      } catch (err) {
        return Promise.reject(null)
      }

    }
  }


  /**
   * @description
   * chat notification push
   *
   *
   */
  async chatMessageNotification(payload: any) {
    try {
      // const res: any = await this.$http.post(URL.chatNotifications,payload).toPromise()
    } catch (err) {
      return;
    }
  }

  navigateToProfile(userId: string, id?: string) {
    if (userId && !id) {
      this.$router.navigate(['/dashboard/profile'], { queryParams: { userId } });
      return;
    }
    else if (userId && id) {
      if (userId === id) {
        this.$router.navigateByUrl('/dashboard/profile');
        return;
      } else {
        this.$router.navigate(['/dashboard/profile'], { queryParams: { userId } });
        return;
      }
    }

  }

  /**
  * Determine the mobile operating system.
  * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
  *
  * @returns {String}
  */
  getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return true;
      // return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return true;
      // return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) || !window) {
      return true;
      // return "iOS";
    }
    return false;
  }

  get isMobileDevice(): boolean {
    return this.getMobileOperatingSystem();
  }

  encryptViaCrypto(str: string): Promise<string> {
    str = str.trimLeft();
    str = str.trimRight();
    return new Promise((resolve, reject) => {
      const res = CryptoJS.AES.encrypt(JSON.stringify({ str }), this.secretKey).toString()
      resolve(res);

    })
  }

  decryptViaCrypto(stri: string): string {
    const res = CryptoJS.AES.decrypt(stri, this.secretKey).toString(CryptoJS.enc.Utf8)
    if (!res) return ''
    if (res.includes('str')) {
      const { str } = JSON.parse(res);
      return str;
    }
    return res;
  }
  fileReaderBase64ToFile(file: any) {
    return new Promise((resolve, reject) => {
      dataURLtoFile(file, null, (result) => {
        this.uploadImage(result, function (imageURL) {
          resolve(imageURL.Location)

        })
      })
    });
  }
  uploadImage(file: any, callback?) {
    this.$azureUpload.uploadFile(file).then(res => {
      callback(res);
    })
  }

  /**
   * @description method to upload base 64 image on aws s3
   */
  async uploadBase64Aws(base64: any) {
    try {
      const res = await this.fileReaderBase64ToFile(base64);
      return res;
    } catch (err) {
      return null;

    }
  }

  get getPageTitle() {
    return this.$title.getTitle();
  }

  setPageTitle(title?: string) {
    this.$title.setTitle(title ? title : 'Avtopia');
  }

  DateToMs(date: any, endDate?: any) {
    if (!date) { return null }
    /*------------*/
    if (endDate) {
      let eDate = new Date(date);
      return +eDate.setHours(23, 59, 59)
    } else {
      return +new Date(date);
    }
  }
  redirectToAnotherTab(url) {
    const anchor = document.createElement("a");
    anchor.setAttribute("href", url);
    anchor.setAttribute("target", "_blank");
    anchor.click();
  }
  countFilter(data) {
    let count = 0;
    for (const k in data) {
      if (data[k] != null && data[k] != '') {
        ++count;
      }
    }
    return count;
  }


  downloadFile(data: any, fileName: string, format: string, domId: string) {

    const blob = new Blob([data], { type: `text/${format}` });

    const url = window.URL.createObjectURL(blob);
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
      return;
    }

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    let d = document.getElementById(domId);
    if (d != null) d.appendChild(link);
    link.click();

    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  isValidId(ID: string) {
    if ((/^[a-f\d]{24}$/i.test(ID))) {
      return true;
    } else {
      this.$toast.error(INVALID_ID_ERROR);
      this.navigateNotFound();
    }
  }

  navigateNotFound() {
    this.$router.navigate(['404']);
  }

  removeEmptyValueFromObject(obj: any) {
    for (let propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
        delete obj[propName];
      }
    }
    return obj;
  }

  trim(data) {
    for (const item in data) {
      if (typeof data[item] === 'string') {
        data[item] = data[item].trim();
      }
    }
    return data;
  }

  toBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    })
  }

  setDataInLocalStorage(name: string, data: any) {
    localStorage.setItem(name, JSON.stringify(data));
  }
  getDataFromLocalStorage(name: string) {
    return JSON.parse(localStorage.getItem(name));
  }

  removeDataFromLocalStorage(name: string) {
    localStorage.removeItem(name);
  }

  compareStrings(str1: string, str2: string) {
    // 1 when str1 is greater
    //  0 when both string is same
    // -1 when both string is lower
    return str1.localeCompare(str2);
    // str1 < -1
    // str1 = 0
    // str1 > +1
  }

  fetchLocation(): Promise<any> {
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          const params = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }
          resolve(params);
        }, err => {
          // this.$popup.successBox(LOCATION_ACCESS_CONSTANTS.ALLOW)
          // reject(err);
        })
      }
    })
  }



  // async getDevice_Token_Id() {
  //   const deviceId = this.$storageService.deviceDetail(6)
  //   try {
  //     const deviceToken = await this.$messagingService.requestPermission();
  //     if (deviceToken) {
  //       return Promise.resolve({ deviceToken, deviceId })
  //     }
  //   } catch (err) {
  //     const deviceToken = '12431212121'
  //     return Promise.reject({ deviceToken, deviceId })
  //   }
  // }



  removeDuplicateObject(arr: any[]) {
    return _.map(
      _.uniq(
        _.map(arr, function (obj) {
          return JSON.stringify(obj);
        })
      ), function (obj) {
        return JSON.parse(obj);
      }
    );
  }



}
